module.exports = __webpack_public_path__ + "img/no.a85974ba.png";